import { ECS } from '../state';
import { urls } from '@/config/assets';
import { Billboard } from '@react-three/drei';
import { getUrlBoolean } from '~/helpers/UrlParam';

const debug = getUrlBoolean('debug');

const REPEAT = 8;

export const BeerGround = ({ stage }) => {
  const refEntity = useRef();
  const refRoot = useRef();

  const [
    //
    tGround,
    tFg,
    tTrees,
    tBg,
    tCorn1,
    tCorn2,
  ] = useAsset([
    //
    urls.t_ground,
    urls.t_fg,
    urls.t_trees,
    urls.t_bg,
    urls.t_corn1,
    urls.t_corn2,
  ]);

  tGround.wrapS = tGround.wrapT = RepeatWrapping;
  tGround.repeat.set(5 * REPEAT, 5);

  tFg.wrapS = tFg.wrapT = RepeatWrapping;
  tFg.repeat.set(REPEAT, 1);

  tTrees.wrapS = tTrees.wrapT = RepeatWrapping;
  tTrees.repeat.set(REPEAT, 1);

  tBg.wrapS = tBg.wrapT = RepeatWrapping;
  tBg.repeat.set(REPEAT, 1);

  tCorn1.wrapS = tCorn1.wrapT = RepeatWrapping;
  tCorn1.repeat.set(REPEAT * 2, 1);
  tCorn2.wrapS = tCorn2.wrapT = RepeatWrapping;
  tCorn2.repeat.set(REPEAT * 4, 1);

  const cornTexture = stage == 1 ? tCorn1 : tCorn2;

  useFrame(() => {
    const player = players.entities[0];
    const x = player.position.x;
    const repeats = Math.floor(x / REPEAT);
    refRoot.current.position.x = repeats * REPEAT;
  });

  return (
    <ECS.Entity ref={refEntity}>
      {/* <ECS.Component
        name="position"
      /> */}
      {/* <ECS.Component name="followPlayer" /> */}
      <ECS.Component name="three">
        <group ref={refRoot}>
          <mesh
            name="sky"
            position={[0, 1.5, -20]}
            scale={[2, 4, 2]}
          >
            <planeGeometry args={[4 * REPEAT, 1]} />
            <meshBasicMaterial
              map={tBg}
              transparent
            />
          </mesh>

          <mesh
            name="trees"
            position={[0, 1, -15]}
            scale={[2, 2, 2]}
          >
            <planeGeometry args={[4 * REPEAT, 1]} />
            <meshBasicMaterial
              map={tTrees}
              transparent
            />
          </mesh>

          <mesh
            rotation-x={degToRad(-90)}
            position={[0, 0, -10]}
            visible={!debug}
          >
            <planeGeometry args={[20 * REPEAT, 20]} />
            <meshBasicMaterial
              map={tGround}
              transparent
            />
          </mesh>

          {stage == 1 && (
            <group>
              <mesh
                name="corn-layer4"
                position={[0, 0.35, -6]}
                scale={0.55}
              >
                <planeGeometry args={[8 * REPEAT, 1]} />
                <meshBasicMaterial
                  map={tCorn1}
                  transparent
                  alphaTest={0.5}
                />
              </mesh>
              <mesh
                name="corn-layer3"
                position={[0, 0.35, -4]}
                scale={0.55}
              >
                <planeGeometry args={[8 * REPEAT, 1]} />
                <meshBasicMaterial
                  map={tCorn1}
                  transparent
                  alphaTest={0.5}
                />
              </mesh>
              <mesh
                name="corn-layer2"
                position={[0, 0.35, -2]}
                scale={0.55}
              >
                <planeGeometry args={[8 * REPEAT, 1]} />
                <meshBasicMaterial
                  map={tCorn1}
                  transparent
                  alphaTest={0.5}
                />
              </mesh>

              <mesh
                name="corn-layer1"
                position={[0, 0.35, -0.01]}
                scale={0.55}
              >
                <planeGeometry args={[8 * REPEAT, 1]} />
                <meshBasicMaterial
                  map={tCorn1}
                  transparent
                  alphaTest={0.5}
                />
              </mesh>
            </group>
          )}

          {stage == 2 && (
            <group>
              <mesh
                name="corn-layer3"
                position={[0, 0.35, -6]}
                scale={0.7}
              >
                <planeGeometry args={[16 * REPEAT, 1]} />
                <meshBasicMaterial
                  map={tCorn2}
                  transparent
                  alphaTest={0.5}
                />
              </mesh>
              <mesh
                name="corn-layer2"
                position={[0, 0.35, -2]}
                scale={0.7}
              >
                <planeGeometry args={[16 * REPEAT, 1]} />
                <meshBasicMaterial
                  map={tCorn2}
                  transparent
                  alphaTest={0.5}
                />
              </mesh>

              <mesh
                name="corn-layer1"
                position={[0, 0.35, -0.01]}
                scale={0.6}
              >
                <planeGeometry args={[16 * REPEAT, 1]} />
                <meshBasicMaterial
                  map={tCorn2}
                  transparent
                  alphaTest={0.5}
                />
              </mesh>
            </group>
          )}

          <mesh
            name="ground"
            position={[0, -0.2, 0]}
            scale={[2, 2, 2]}
          >
            <planeGeometry args={[2 * REPEAT, 1]} />
            <meshBasicMaterial
              map={tFg}
              transparent
            />
          </mesh>
        </group>
      </ECS.Component>
    </ECS.Entity>
  );
};
